import Axios from "../config/config";

//INSTRUCTOR API
export const INSTRUCTOR_LIST = async (body) => {
    try {
        const response = await Axios.post('instructor-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const ADD_INSTRUCTOR = async (body) => {
    try {
        const response = await Axios.post("add-instructor/", body, {
            headers: {
                "Content-Type": "multipart/form-data", // 
            },
        });
        return response;
    } catch (error) {
        console.error("ADD_LEARNER ERROR:", error?.response?.data || error.message);
        throw error;
    }
};


export const EDIT_INSTRUCTOR = async (body) => {
    try {
        const response = await Axios.post('edit-instructor/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_INSTRUCTOR = async (body) => {
    try {
        const response = await Axios.post('view-instructor/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
